import React from 'react';
import IntegrationSymbol from './IntegrationSymbol';

const IntegrationsHome = ({ integrations = [], onSelectIntegration }) => {
    return (
        <div className="context-home-container">
            <div className="overview-stats integrations-tile-grid">
                {integrations.length > 0 ? (
                    integrations.map((integration) => (
                        <button
                            key={integration.id}
                            type="button"
                            className="stat-card integration-tile"
                            onClick={() => onSelectIntegration(integration)}
                        >
                            <div className="integration-symbol">
                                <IntegrationSymbol symbol={integration.symbol} logo={integration.logo} />
                            </div>
                            <h4>{integration.name || 'Unnamed Integration'}</h4>
                            <p className="stat-label integration-description">{integration.description || 'No description available.'}</p>
                        </button>
                    ))
                ) : (
                    <div className="stat-card integration-empty-tile">
                        <h4>No Integrations Found</h4>
                        <p className="stat-label">No available integrations were returned.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default IntegrationsHome;
